import { render, staticRenderFns } from "./modalTermoCompromisso.vue?vue&type=template&id=146d44f6&scoped=true&lang=pug&"
import script from "./modalTermoCompromisso.vue?vue&type=script&lang=js&"
export * from "./modalTermoCompromisso.vue?vue&type=script&lang=js&"
import style0 from "./modalTermoCompromisso.vue?vue&type=style&index=0&id=146d44f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d44f6",
  null
  
)

export default component.exports